import moment from 'moment-timezone';

type TimezoneAbbreviation = {
  date: string;
  time: string;
  dateOnly: string;
};

/**
 * Formats the time with the given time zone.
 * If the time zone is not provided, the time will be formatted in UTC.
 * The time will be formatted as "h:ma z" (e.g., "3:40pm EET").
 *
 * @param isoDate - The UTC date string in ISO 8601 format (e.g., "2024-12-02T13:40:00Z").
 * @param timeZone - The IANA time zone name (e.g., "Europe/Kyiv").
 *
 * @returns An object with the formatted date and time.
 *
 * @example
 * const formattedTime = formatTimeWithTimeZone("2024-12-02T13:40:00Z", "Europe/Kyiv");
 * console.log(formattedTime); // "3:40pm (EET)"
 */
export function formatTimeWithTimeZone(isoDate: string, timeZone?: string): TimezoneAbbreviation {
  let date;
  if (timeZone) date = moment(isoDate).tz(timeZone);
  else date = moment(isoDate).utc();

  return {
    date: date.format('YYYY-MM-DD h:ma'),
    time: date.format('h:mm A'),
    dateOnly: date.format('YYYY-MM-DD'),
  };
}
